import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: "vocabulary-mcq"
};
const _hoisted_2 = {
  class: "title"
};
const _hoisted_3 = ["innerHTML"];
const _hoisted_4 = {
  class: "question"
};
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = {
  class: "answer"
};
const _hoisted_7 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_8 = {
  class: "menu"
};
const _hoisted_9 = ["innerHTML"];
const _hoisted_10 = {
  class: "check-box"
};
const _hoisted_11 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_checkbox = _resolveComponent("el-checkbox");
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("p", {
    innerHTML: $props.questionInfo.itemInstruction
  }, null, 8, _hoisted_3)]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
    class: "question-text",
    innerHTML: $setup.itemText
  }, null, 8, _hoisted_5), _createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.questionInfo.questionGroupList, (questionItem, questionIndex) => {
    return _openBlock(), _createElementBlock("div", {
      class: "answer-item",
      key: 'que' + questionIndex
    }, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, _toDisplayString(questionIndex + $props.questionInfo.menu), 1), _createElementVNode("p", {
      style: {
        "flex": "1"
      },
      class: "questionStem",
      innerHTML: questionItem.questionList[0].questionStem
    }, null, 8, _hoisted_9)]), _createElementVNode("div", _hoisted_10, [_createVNode(_component_el_checkbox_group, {
      modelValue: $setup.answer[questionItem.questionList[0].questionId],
      "onUpdate:modelValue": $event => $setup.answer[questionItem.questionList[0].questionId] = $event,
      max: 2
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(questionItem.choiceList, (answerItem, answerIndex) => {
        return _openBlock(), _createBlock(_component_el_checkbox, {
          key: 'answer' + answerIndex,
          label: String.fromCharCode(65 + answerIndex),
          size: "large",
          onChange: $setup.setAnswer
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(String.fromCharCode(65 + answerIndex)) + ". ", 1), _createElementVNode("span", {
            innerHTML: answerItem.choiceText
          }, null, 8, _hoisted_11)]),
          _: 2
        }, 1032, ["label", "onChange"]);
      }), 128))]),
      _: 2
    }, 1032, ["modelValue", "onUpdate:modelValue"])])]);
  }), 128))])])]);
}